import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrentOrg } from 'auth/hooks'
import { pickAllowedAdminLocale } from '../adminLocales'

/** Keeps i18n language within the current org's supported admin locales. */
const OrgAdminLocaleSync = () => {
  const organization = useCurrentOrg()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (!organization?.id) {
      return
    }
    const next = pickAllowedAdminLocale(i18n.language, organization)
    if (next && i18n.language.split('-')[0] !== next) {
      void i18n.changeLanguage(next)
    }
  }, [organization, organization?.id, organization?.supportedAdminLocales, organization?.defaultAdminLocale, i18n])

  return null
}

export default OrgAdminLocaleSync
